import { render, staticRenderFns } from "./CbsReferencePicker2.vue?vue&type=template&id=4b296277&scoped=true"
import script from "./CbsReferencePicker2.vue?vue&type=script&lang=js"
export * from "./CbsReferencePicker2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b296277",
  null
  
)

export default component.exports